<template>
  <el-dialog
    title="事项指标管理"
    :visible.sync="dialogVisible"
    width="560px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
  <div class="container-dialog">
      <el-form
        :model="formInline"
        class="demo-form-inline"
        ref="form"
        :rules="rules"
      >
        <el-form-item
          label="指标名称(考评内容)"
          prop="zbmc"
        >
          <el-input
            v-model="formInline.zbmc"
            placeholder="请输入指标名称(考评内容)"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curId: {
      type: String,
      default: ""
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      info: {},
      loading: false,
      formInline: {
        zbmc: '',
        isAdd: true,
        index: ''
      },
      rules: {
        zbmc: [
          {
            required: true,
            message: "请输入指标名称(考评内容)",
            trigger: "blur"
          }
        ],
      }
    };
  },
  mounted() {
    if (!this.curItem.isAdd) {
      this.formInline = JSON.parse(JSON.stringify(this.curItem));
    }
  },
  methods: {
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async onSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.$emit("updateData", this.formInline);
          this.handleClose();
        }
      });
    },
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none !important;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-input {
  width: 330px;
}
.container-dialog {
  padding: 10px;
  .item-box {
    display: flex;
    align-items: center;
  }
  .item-box1 {
    .item {
      margin-right: 8px;
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 24px;
      color: #494c4f;
    }
    .cs {
      margin-right: 8px;
      background: rgba(235, 53, 56, 0.1);
      border-radius: 4px;
      padding: 2px 8px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #eb3538;
    }
  }
  .item-box2 {
    margin-top: 12px;
    .icon {
      // width: 22px;
      height: 18px;
      margin-right: 10px;
    }
    .label {
      padding: 0;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #92979c;
      margin-right: 12px;
    }
    .value {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #494c4f;
    }
  }
  .item-box3 {
    margin-top: 12px;
    .item1 {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #494c4f;
      margin-right: 21px;
    }
    .item2 {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      margin-right: 8px;
    }
    .item3 {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #494c4f;
    }
  }
}

/deep/.demo-drawer__footer {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  background: #fff;
}

/deep/ .el-dialog {
  margin-top: 18vh !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/customTask/components/indexDialog.vue